// extracted by mini-css-extract-plugin
module.exports = {"callout":"_callout--bkTTd","expandIconContainer":"_expandIconContainer--wWKWc","expandIcon":"_expandIcon--28XXG"};